export const SET_CATEGORIA = 'SET_CATEGORIA';
export const LOADING_CATEGORIAS = 'LOADING_CATEGORIAS';